import { Maybe } from 'graphql/jsutils/Maybe';
import { FormGroup } from '@angular/forms';
import { Component, Input } from '@angular/core';

import { RecurrenceScheduleDateRangeComponent } from './recurrency-schedule-date-range';
import { RecurrenceScheduleConfiguratorComponent } from './recurrency-schedule-configurator';
import { RecurrenceScheduleControls } from './recurrence-schedule.form-group';

import { DisplayAfterDirective } from '@iss/core/forms';

@Component({
  selector: 'wo-recurrence-schedule',
  templateUrl: './recurrence-schedule.component.html',
  styleUrls: [ './recurrence-schedule.component.scss' ],
  standalone: true,
  imports: [
    RecurrenceScheduleDateRangeComponent,
    DisplayAfterDirective,
    RecurrenceScheduleConfiguratorComponent,
  ],
})
export class RecurrenceScheduleComponent {
  @Input({ alias: 'issFormGroup', required: true }) public formGroup!: FormGroup<RecurrenceScheduleControls>;
  @Input() public readonly: Maybe<boolean>;
  @Input() public minStart: Maybe<Date> = new Date();
}
